import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminLayoutComponent, AuthGuard, MapaCoreModule} from '@mapa/core';

const routes: Routes = [
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./feature/home/home.module').then(m => m.HomeModule)
            },
            {
                path: 'solicitacao',
                canActivateChild: [AuthGuard],
                data: {breadcrumbs: 'Solicitação de Importação'},
                loadChildren: () => import('./feature/solicitacao/solicitacao.module').then(m => m.SolicitacaoModule)
            },
            {
                path: 'estacao-quarentenaria',
                canActivateChild: [AuthGuard],
                data: {breadcrumbs: 'Estação Quarentenária'},
                loadChildren: () => import('./feature/estacao-quarentenaria/estacao-quarentenaria.module').then(m => m.EstacaoQuarentenariaModule)
            },
            {
                path: 'representante-legal',
                canActivateChild: [AuthGuard],
                data: {breadcrumbs: 'Representante Legal'},
                loadChildren: () => import('./feature/representante-legal/representante-legal.module').then(m => m.RepresentanteLegalModule)
            }
        ]
    }
];

@NgModule({
    imports: [
        MapaCoreModule,
        RouterModule.forRoot(routes, {
            useHash: false,
            enableTracing: true,
            relativeLinkResolution: 'legacy'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



